import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { OverridableLink } from '../components/Link';
import { useAppComponents } from './useAppComponents';
export function useAppLink() {
    const { AppLink } = useAppComponents();
    return AppLink;
}
export function useAppLinkUi() {
    const { AppLink } = useAppComponents();
    const Component = (props) => (_jsx(OverridableLink, { component: AppLink, ...props }));
    Component.displayName = 'AppLink';
    return Component;
}
export function useAppLinkStyled(StyledComponent) {
    const { AppLink } = useAppComponents();
    const Component = useMemo(() => StyledComponent.withComponent(AppLink), [AppLink, StyledComponent]);
    return Component;
}
